import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        breadcrumbs: [],
        customer: {}
    },
    mutations: {
        set_breadcrumbs(state,data){
            state.breadcrumbs = data;
        },
        set_customer(state,data){
          state.customer = data;
      }
      },
      actions: {
        setBreadCrumps({commit}, data){
          commit('set_breadcrumbs',data);
        },
        setCustomer({commit}, data){
          commit('set_customer', data);
        }
      },
      getters : {
        getBreadCrumps: state => state.breadcrumbs,
        getCustomer: state => state.customer,
      }
})